const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReports/loadCumulDefsExtrasHandlers.ts';
import Imm from 'immutable';
import { incCounter, decCounter } from '../../utils/reducerUtils';
import { IKisApiHandlersMap } from '../../defs/actionTypes';
import { LoadCumulDefsExtrasAction } from '../../actions/labReportsActions';
import { Logger } from '../../services/KisLoggerService';

const Log = Logger('labReports/loadCumulDefsExtras');

export const loadCumulDefsExtrasHandlers: IKisApiHandlersMap<LoadCumulDefsExtrasAction> = {
    pending: state => {
        return incCounter(state, ['loading', 'cumulDefsExtras']);
    },
    success: (state, action) => {
        const filterIcode = action.meta && action.meta.filterIcode;

        if (!filterIcode) {
            Log.warn('Cannot store cumulDefs extras, because the filterIcode is missing!', action);
        } else {
            const payload = Imm.fromJS(action.payload || {});
            const extras = Imm.fromJS({
                Legende: payload.get('Legende') || '',
                Disclaimer: payload.get('Disclaimer') || '',
            });

            let numUpdated = 0;
            state.get('cumulDefs').forEach((cumulDefs: Imm.Map<string, any>, idx: any) => {
                if (cumulDefs.get('FilterIcode') === filterIcode) {
                    state = state.setIn(['cumulDefs', idx], cumulDefs.merge(extras));
                    numUpdated++;
                }
            });

            if (!numUpdated) {
                Log.warn(`Could not store cumulDefs extras: cumulDefs not found: ${filterIcode}`);
            }
        }

        return decCounter(state, ['loading', 'cumulDefsExtras']);
    },
    failure: (state, action) => {
        Log.warn('Failed to load the cumulDefs extras!', action);
        return decCounter(state, ['loading', 'cumulDefsExtras']);
    },
};
